import { Loader } from "lucide-react"

const ButtonLoading = () => {
  return (
    <Loader className="animate-spin" />
  )
}
export default ButtonLoading